import { apiClient } from '../lib/apiClient';

/**
 * Journal AI analysis, aquarium story and milestones
 * (backend src/routes/journalAi.ts, journalDashboard.ts, journalTimeline.ts,
 * mounted under /api/v1/aquariums/:aquariumId/journal). The AI calls run only
 * when the user asks for them; answers come back in the UI language (apiClient
 * sends it as Accept-Language).
 */

export interface JournalAiObservation {
  type: 'ai_observation';
  summary: string;
  observations: string[];
  suggestedActions: string[];
  riskIndicators: string[];
  generatedAt: string;
}

export interface AquariumStory {
  aquariumId: string;
  story: string;
  generatedAt: string;
  /** 0 = no journal entries yet (no AI call was made). */
  entryCount: number;
}

export interface JournalMilestone {
  id: string;
  aquariumId: string;
  title: string;
  contentPreview: string | null;
  tags: string[];
  isMilestone: boolean;
  createdAt: string;
}

function base(aquariumId: string): string {
  return `/api/v1/aquariums/${encodeURIComponent(aquariumId)}/journal`;
}

export async function analyzeJournalEntry(aquariumId: string, entryId: string): Promise<JournalAiObservation> {
  const res = await apiClient.post<{ data: JournalAiObservation }>(
    `${base(aquariumId)}/${encodeURIComponent(entryId)}/analyze`,
    {},
  );
  return res.data;
}

export async function generateAquariumStory(aquariumId: string): Promise<AquariumStory> {
  const res = await apiClient.post<{ data: AquariumStory }>(`${base(aquariumId)}/story`, {});
  return res.data;
}

export async function getJournalMilestones(aquariumId: string): Promise<JournalMilestone[]> {
  const res = await apiClient.get<{ data: { milestones: JournalMilestone[] } }>(`${base(aquariumId)}/timeline/milestones`);
  return res.data.milestones;
}
